import React from 'react'
import PropTypes from 'prop-types'
import PhoneInput from 'react-phone-input-2'
import 'react-phone-input-2/lib/style.css'

function PhoneInputField({
  name = 'phone',
  value = '',
  onChange,
  onBlur,
  required = false,
  invalid = false,
  country = 'ca',
  className,
}) {
  const digits = String(value || '').replace(/\D/g, '')

  return (
    <PhoneInput
      country={country}
      value={digits}
      enableSearch
      countryCodeEditable={false}
      specialLabel=""
      placeholder=""
      containerClass={className}
      onChange={(val) => {
        if (onChange) onChange(val ? `+${val}` : '')
      }}
      inputProps={{
        name,
        required,
        autoComplete: 'tel',
        'aria-invalid': invalid ? 'true' : undefined,
        onBlur,
      }}
    />
  )
}

PhoneInputField.propTypes = {
  name: PropTypes.string,
  value: PropTypes.string,
  onChange: PropTypes.func,
  onBlur: PropTypes.func,
  required: PropTypes.bool,
  invalid: PropTypes.bool,
  country: PropTypes.string,
  className: PropTypes.string,
}

export default PhoneInputField
